import { makeHasEnded } from '@/competitions/_common/utils.ts';

import { ADVENT_2024_CAMPAIGN_END_DATE } from '../../../config.ts';

export const useHasEnded = makeHasEnded(ADVENT_2024_CAMPAIGN_END_DATE);
